import { render, staticRenderFns } from "./Comissions.vue?vue&type=template&id=11685b0e&scoped=true&"
import script from "./Comissions.vue?vue&type=script&lang=js&"
export * from "./Comissions.vue?vue&type=script&lang=js&"
import style0 from "./Comissions.vue?vue&type=style&index=0&id=11685b0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11685b0e",
  null
  
)

export default component.exports